import { CompanyTypeEnum } from "./company-type-enum";

export class PlantsDropDown {
    plantId: number;
    plantName: string;
    plantType?: string;
    company?:CompanyTypeEnum
    plantCode?: string

    /**
     * 
     * @param plantId 
     * @param plantName 
     */
    constructor(plantId: number, plantName: string, plantType?:string,company?:CompanyTypeEnum,plantCode?: string) {
        this.plantId = plantId;
        this.plantName = plantName;
        this.plantType = plantType;
        this.company = company;
        this.plantCode = plantCode
    }

}